module.exports = __webpack_public_path__ + "img/refah.e77fcbd.png";